export default __webpack_public_path__ + "static/media/jetmover.33487ce9.png";